import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { CloudtrailService } from '../../service';

export type MultiRegionTrailConfig = typeof MultiRegionTrailConfig._.Config;

export const MultiRegionTrailConfig = IntegrationConfig.make({
  service: CloudtrailService,
  name: Integration_Handler_Names_Enum.MultiRegionTrail,
  configSchema: z.object({}),
});
